import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { DateTime } from "luxon";
import { makeObservable, observable } from "mobx";

@injectable()
export class DatesFilterViewmodel extends BaseViewModel {
    @observable
    from: DateTime = DateTime.now().minus({ days: 1 });

    @observable
    to: DateTime = DateTime.now();

    constructor() {
        super();
        makeObservable(this);
    }
}
